import { Label } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';

type Props = {
  className?: string;
};

export const ModuleBadge = ({ className }: Props) => {
  return (
    <S.Label color="grey" className={className} data-testid="ac-gt-label">
      AC + GT
    </S.Label>
  );
};

const S = {
  Label: styled(Label)`
    display: inline-block;
    white-space: nowrap;
    height: 26px !important;
  `,
};
